import { atom } from "recoil";
import { YourOrder } from "../lib/model";

export const orderState = atom<YourOrder>({
  key: "orderState",
  default: null,
})

// QR 주문 세션이 활성인지(Splash 통과 후 AppStack 진입). LeaveGuard(beforeunload)가 이 값으로만 무장한다.
// full reload 시 default(false)로 돌아가 Splash/expired에선 자동 비활성.
export const sessionActiveState = atom<boolean>({
  key: "sessionActiveState",
  default: false,
})
